import { currentWebsite } from '../core/target-website';
import { getWidgetServices } from '../core/userway';
import { utmLeadParameters } from '../core/utm-lead-parameters';

export const generateUtmLink = () => {
  const baseUrl = 'https://UserWay.org';
  const { paidAi } = getWidgetServices();
  const source = currentWebsite();
  const widgetType = paidAi ? 'widget_mini' : 'free_widget_mini';
  const target = 'widget_footer';

  return utmLeadParameters(baseUrl, { source, target, widgetType });
};
